import { render, staticRenderFns } from "./EstrattocontoDetails.vue?vue&type=template&id=4a408dc3&"
import script from "./EstrattocontoDetails.vue?vue&type=script&lang=js&"
export * from "./EstrattocontoDetails.vue?vue&type=script&lang=js&"
import style0 from "./EstrattocontoDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EstrattocontoDetails.vue"
export default component.exports